(ns app.front.view.group.admin.integration.availability
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.integration.common :as iconf]
            [app.front.view.group.admin.subs :as gas]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::stored-config
  :<- [::gas/group]
  :-> :group/availability-integration-config)

(defn str-edit [{:keys [tr k tr-key config]}]
  [:div.mt-4
   [ui/text-input {:id         (name k)
                   :label-text (tr [(or tr-key k)])
                   :required   true
                   :light      true
                   :value      (get config k "")
                   :on-change  #(rf/dispatch-sync [::iconf/set-attr k (futil/tval %)])}]])

(defmulti config-editor (fn [_ {service-type :integration-config/service}] service-type))

(defmethod config-editor :default [ctx config]
  [iconf/generic-editor ctx config])

;; implement a fancy editor with custom titles for Microsoft 365
(defmethod config-editor :integration-config.service/m365
  [{:keys [tr]} config]
  [:div
   [str-edit (util/mmap {:k      :integration-config/client-id
                         :tr-key :integration-config.m365/client-id}
                        tr config)]
   [str-edit (util/mmap {:k      :integration-config/tenant-id
                         :tr-key :integration-config.m365/tenant-id}
                        tr config)]
   [:div.mt-4
    [ui/text-input {:id            "secret-input"
                    :auto-complete "off"
                    :label-text    (tr [:integration-config.m365/client-secret])
                    :required      true
                    :light         true
                    :placeholder   (tr [:integration-config/editing-secret-overrides])
                    :value         (:integration-config/client-secret config)
                    :on-change     #(rf/dispatch-sync [::iconf/set-attr
                                                       :integration-config/client-secret
                                                       (futil/tval %)])}]]
   [:div.text-xs.font-bold.mt-2 (tr [:api-key-ui/display-once-warning])]])

(defn view [{:keys [tr group]}]
  [iconf/config-editor-page
   (util/mmap
     {:group-id                   (:db/id group)
      :integration-type           :integration-config.type/availability
      :stored-config-subscription [::stored-config]
      :save-command               :group/save-availability-integration}
     tr config-editor)])
